import { useTranslation } from "react-i18next"
import { Alert } from "../Alert"

interface AlertSectionProps {
  isIncomplete?: boolean
  errors?: string[]
}

export function AlertSection({ errors = [], isIncomplete }: AlertSectionProps) {
  const { t } = useTranslation()

  return errors.length || isIncomplete ? (
    <div className="my-1">
      {errors.length ? (
        <Alert status="critical" text={t("client.review.alerts.error")}>
          <div className="flex flex-col">
            <ul className="list-disc list-inside [font-size:var(--alias-font-caption-font-size)]">
              {errors.map((error, index) => (
                <li
                  aria-label={`Unaddressed error ${
                    errors.length > 1 ? index + 1 : ""
                  }: ${error}`}
                  key={error + index}
                >
                  {error}
                </li>
              ))}
            </ul>
          </div>
        </Alert>
      ) : null}
      <div className="mb-3" />
      {isIncomplete ? (
        <Alert status="attention" text={t("client.review.alerts.empty")} />
      ) : null}
    </div>
  ) : null
}
